import { MultiSelect, MultiSelectFilterChangeEvent } from "@progress/kendo-react-dropdowns"
import { FieldRenderProps, FieldWrapper } from "@progress/kendo-react-form";
import { FunctionComponent, useMemo, useState } from "react"
import { Label } from "@progress/kendo-react-labels";
import { Api } from "../../../redux/api/BaseApi";
import { UserApi } from "../../../redux/api/UserApi";
import UserFynd from "./UserFynd";
import {
  ListBox,
  ListBoxItemClickEvent,
  ListBoxToolbar,
} from "@progress/kendo-react-listbox";
import { IStaff } from "../../../types/IStaff";
import { filterBy, FilterDescriptor } from "@progress/kendo-data-query";
const AssociatedContacts: FunctionComponent<FieldRenderProps> = props => {
  const {
    label,
    id,
    valid,
    disabled,
    optional,
    assContactIds,
    companyId,
    companyTypeId,
    onChange,
  } = props;
  //const { data : userProfile } = Api.useGetUserProfileQuery();  
  const { data: associatedUsers } = UserApi.useGetUsersByIdsQuery(assContactIds?.length ? assContactIds?.join(',') : '0');
  const { data: assContactConfig } = Api.useGetAssContactConfigQuery(companyTypeId, { skip: !companyTypeId });
  const { data: endUsers } = Api.useGetUsersQuery({ companyId: companyId, locationId: null });
  const [filter, setFilter] = useState<FilterDescriptor>(null);
  const [globalContactsIds, setGlobalContactIds] = useState(assContactIds || []);
  const [selectedId, setSelectedId] = useState();
  const SELECTED_FIELD = "selected";
  //add usememo to stop rerendering on every keypress of the call description changing
  const endUsersFormatted = useMemo(() => setDisplayName(endUsers) || [], [endUsers]);
  const associatedUsersFormatted = setDisplayName(associatedUsers) || [];

  function setDisplayName(data) {
    return data?.map(a => {
      return {
        ...a,
        "Display_Name":
          a[a.Secondary_User_Classification] ?
            `${a.FullName} - ${a[a.Secondary_User_Classification]}`
            : a.FullName,
        [SELECTED_FIELD]: a.ID === selectedId
      }
    })
  }
  const globalContactSelected = (e) => {
    console.log('globalContacts', globalContactsIds, e.Contact_Id, [...globalContactsIds, e.Contact_Id])

    let newArray = [...globalContactsIds, e.Contact_Id];
    setGlobalContactIds(newArray)

    onChange({ value: newArray.map(g => { return { ID: g } as IStaff }) });

    console.log('globalContacts', newArray?.length)
  }

  const handleToolBarClick = (e) => {
    let toolName = e.toolName || "";
    if (toolName === "remove") {
      let newArray = [...globalContactsIds];
      newArray.splice(newArray.indexOf(selectedId), 1)

      setGlobalContactIds(newArray)

      onChange({ value: newArray.map(g => { return { ID: g } as IStaff }) });
    }
  };

  const filterChanged = (event: MultiSelectFilterChangeEvent) => {
    setFilter(event.filter)
  }
  return (
    <div>
      <FieldWrapper>
        {
          assContactConfig?.Global
            ? <div>
              <UserFynd {...props} onChange={globalContactSelected} display={null} hideOptions={true} />
              <ListBox
                style={{ height: 100, width: "100%" }}
                data={associatedUsersFormatted}
                textField="Display_Name"
                selectedField={SELECTED_FIELD}
                onItemClick={(e: ListBoxItemClickEvent) => setSelectedId(e.dataItem.ID)}
                toolbar={() => {
                  return (
                    <ListBoxToolbar
                      dataConnected={[]}
                      data={associatedUsersFormatted}
                      selectedField={SELECTED_FIELD}
                      tools={[
                        "remove",
                      ]}
                      //data={associatedUsers}
                      onToolClick={handleToolBarClick}
                    />
                  );
                }
                }
              />
            </div>
            : <>
              <Label
                editorId={id}
                editorValid={valid}
                editorDisabled={disabled}
                optional={optional}>
                {label}
              </Label>
              <MultiSelect filterable={true} onFilterChange={filterChanged} onChange={onChange} value={associatedUsersFormatted}
                popupSettings={{ className: "z500" }} placeholder="Select multiple"
                data={filterBy(endUsersFormatted, filter)}
                dataItemKey="ID" textField="Display_Name" loading={false} /></>
        }


      </FieldWrapper>
    </div>
  )

}

export default AssociatedContacts;